import apiClient from './apiClient'
import { API_PATHS } from '@/constants'
import type { AuthenticatedUser } from '@/types'

export type { AuthenticatedUser }

export const getMe = () => apiClient.get<AuthenticatedUser>(API_PATHS.AUTH.ME)

export const refreshToken = () => apiClient.post(API_PATHS.AUTH.REFRESH)

export const logout = () => apiClient.post(API_PATHS.AUTH.LOGOUT)
